import Head from './../components/Head.vue';
import VideoCard from './../components/VideoCard/index.vue';
import SpocCard from '../components/SpocCourseCard.vue';
import { getUrlParams } from '@/plugins/utils';
import { Empty } from 'zhs-components';
import Footer from '../components/Footer.vue';
import LeftMenuItem from '../components/LeftMenuItem.vue';
export default {
  components: {
    Head,
    VideoCard,
    Empty,
    SpocCard,
    Footer,
    LeftMenuItem
  },
  props: ['menuIdKey', 'type', 'name', 'courseName', 'courseNameMathRandom'],

  async mounted() {
    console.log(this.menuId, 'menuIdKey');
    console.log(this.menuIdKey, 'menuIdKey');
    this.getAuth(); //     if (getUrlParams('type')) {
    //   this.courseType = getUrlParams('type')
    //   await this.getMoocSet()
    //   this.getCourseList()
    //   this.getMenuData()
    // }
    // this.courseType = this.courseType

    await this.getMoocSet();
    this.getCourseList();
    this.getMenuData();
  },

  watch: {
    classifyId: {
      handler(value) {
        this.getMenuData();
      }

    },
    courseName: {
      handler(val) {
        this.getCourseList();
      },

      deep: true
    },
    courseNameMathRandom: {
      handler(val) {
        this.getCourseList();
      },

      deep: true
    }
  },

  data() {
    return {
      showMoreBtn: false,
      // menuId: this.$utils.getUrlParams('menuId'),
      menuId: this.menuIdKey,
      title: '',
      pageInfo: {
        pageLimit: 12,
        pageIndex: 1,
        rows: 0
      },
      menuInfo: {},
      classifyId: null,
      searchInfo: {
        collegeId: '',
        courseResultsId: '',
        subjectId: '',
        subjectOneId: '',
        subjectTwoId: '',
        selectedAchievementKind: '',
        collegeName: '',
        subjectName: '',
        termId: '',
        schoolyearId: '',
        semester: '',
        sortNum: 1,
        sortName: '综合排序'
      },
      courseType: '1',
      // 课程类型 1 MOOC开放课  2 SPOC校本课
      moocMenuId: '',
      spocMenuId: '',
      setlist: null,
      // 高级设置
      courseList: [],
      courseName: this.courseName,
      // 搜索关键字
      sortTypeList: [{
        name: '综合排序',
        code: 1
      }, {
        name: '按选课人数降序',
        code: 3
      }, {
        name: '按选课人数升序',
        code: 2
      }],
      classifyList: [],
      // 分类列表
      subjectData: [],
      // 学科列表
      achievementKindData: [],
      // 课程成果
      categoryData: [],
      termData: [],
      // 学期列表
      hiddenMoreClass: true,
      classify_flag: '',
      results_flag: '',
      organ_flag: '',
      subject_flag: '',
      term_flag: '',
      showAffix: true,
      showMoreCourseKind: false,
      // 是否显示更多课程成果
      showMoreCollege: false,
      // 是否显示更多学院
      showMoreSubject: false,
      // 是否显示更多学科
      showMoreTerm: false,
      // 是否显示更多学期
      sortType: 1,
      // 排序类型 1 按选课学生  2 按选课学校数
      authType: 0,
      userInfo: null,
      menuDataLoaded: false,
      resultMap: {},
      reusltColorList: ['#E1212F', '#DA7712', '#00AD3D', '#0089C4', '#7359CA'],
      showResultTag: false // 是否显卡成果标签

    };
  },

  methods: {
    getUserInfo(data) {
      this.userInfo = data;
    },

    // 获取优秀视频列表
    async getCourseList() {
      let courseList = '';

      if (this.courseType == 1) {
        // mooc
        courseList = await this.$http.getExcellentVideoList({
          menuId: this.menuId,
          subjectId: this.searchInfo.subjectId || undefined,
          organId: this.searchInfo.collegeId || undefined,
          semesterId: this.searchInfo.termId || undefined,
          pageNum: 1,
          pageSize: 10,
          teacherName: this.courseName || undefined,
          // organId:this.searchInfo.sortNum
          pageNum: this.pageInfo.pageIndex,
          pageSize: this.pageInfo.pageLimit
        });
      }

      this.courseList = courseList.list || [];
      this.pageInfo.rows = courseList.rowCount || 0;
    },

    // 课程搜索
    handleSearch() {
      this.pageInfo.pageIndex = 1;
      this.getCourseList();
    },

    // 查询高级设置
    async getMoocSet() {
      // console.log(this.moocMenuId);
      if (this.courseType == 1) {
        const res = await this.$http.getMoocSet({
          menu_id: this.menuId // menu_id: this.moocMenuId

        });
        this.setlist = res.res_last;
        console.log('set', res);
      }

      if (this.courseType == 2) {
        const res = await this.$http.getSpocSet({
          menu_id: this.menuId
        });
        this.setlist = res.res_last;
        console.log('set', res);
      }

      this.getCourseResultTagStatus();
      this.setlist.forEach(item => {
        if (item.code == 'sort_type') {
          let sorts = this.courseType == 1 ? {
            1: '综合排序',
            2: '按选课人数升序',
            3: '按选课人数降序'
          } : {
            1: '综合排序',
            2: '按选课人数升序',
            3: '按选课人数降序',
            4: '按发布资源数升序',
            5: '按发布资源数降序'
          };
          this.searchInfo.sortName = sorts[item.code_value];
          this.searchInfo.sortNum = item.code_value;
        }

        if (item.code == 'classify_flag') {
          this.classify_flag = item.code_value;
        }

        if (item.code == 'results_flag') {
          this.results_flag = item.code_value;
        }

        if (item.code == 'organ_flag') {
          this.organ_flag = item.code_value;
        }

        if (item.code == 'subject_flag') {
          this.subject_flag = item.code_value;
        }

        if (item.code == 'term_flag') {
          this.term_flag = item.code_value;
        }
      });
    },

    // 获取课程成果标签状态
    async getCourseResultTagStatus() {
      const res = await this.$http.getAchievementTagStatus({
        menu_id: this.menuId,
        codeName: 'course_achievement_show_flag'
      });
      this.showResultTag = +res > 0 ? true : false;
    },

    // 切换排序
    handleSort(item, index) {
      this.searchInfo.sortNum = item.code;
      this.searchInfo.sortName = item.name;
      this.handleSearch();
    },

    // 获取筛选列表
    async getMenuData() {
      let params = {
        menu_id: this.menuId
      };
      const res = await this.$http.liveManageTree(params); // console.log('筛选列表', res)
      ///分类

      this.classifyList = res.classify_list;
      console.log('分类列表2', this.classifyList);
      this.$nextTick(() => {
        ///判断是否显示分类展开按钮
        const height = parseInt(window.getComputedStyle(this.$refs['classify-list-dom']).height);
        this.showMoreBtn = height > 70;
      }); //归属学院

      this.categoryData = {
        title: '归属学院',
        icon: require('@/assets/images/menu-icon-2.png'),
        content: [{
          id: '',
          name: '全部',
          count: res.organ_tree.courseNum
        }, ...res.organ_tree.children.map(item => {
          return {
            id: item.id,
            name: item.organName,
            count: item.courseNum
          };
        })]
      }; //课程成果
      // this.achievementKindData = {
      //   title: '课程成果',
      //   icon: require('@/assets/images/menu-icon-3.png'),
      //   content: res.results_list.map((item, index) => {
      //     if (item.name == '全部') {
      //       item.id = ''
      //     } else {
      //       if (this.resultMap[item.id]) return
      //       if (index > this.reusltColorList.length) {
      //         this.resultMap[item.id] =
      //           this.reusltColorList[(index % this.reusltColorList.length) - 1]
      //       } else {
      //         this.resultMap[item.id] = this.reusltColorList[index - 1]
      //       }
      //     }
      //     return {
      //       id: item.name === '全部' ? '' : item.id,
      //       name: item.name,
      //       count: item.course_num
      //     }
      //   })
      // }
      //所属学科

      this.subjectData = {
        title: '所属学科',
        icon: require('@/assets/images/menu-icon-4.png'),
        content: [{
          id: '',
          name: '全部',
          count: res.subject_tree.courseNum
        }, ...res.subject_tree.children.map(item => {
          return {
            id: item.id,
            name: item.subjectName,
            count: item.courseNum
          };
        })]
      };
      this.menuDataLoaded = true; //所属学期
      // this.termData = {
      //   title: '所属学期',
      //   icon: require('@/assets/images/semester-icon.png'),
      //   content: res.term_list.map(item => {
      //     return {
      //       id: item.semester_id ? item.semester_id + item.schoolyear_id : '',
      //       name: item.schoolyear + item.semester,
      //       count: item.course_num,
      //       schoolyear_id: item.schoolyear_id,
      //       semester_id: item.semester_id
      //     }
      //   })
      // }
    },

    // 点击分类筛选课程
    searchCourseList(id) {
      this.pageInfo.pageIndex = 1;
      this.classifyId = id;
      this.getCourseList();
    },

    // 清空选中
    clearSelected(index) {
      if (index === 1) {
        this.searchInfo.courseResultsId = '';
      } else if (index === 2) {
        this.searchInfo.collegeId = '';
      } else if (index === 3) {
        this.searchInfo.subjectId = '';
      } else {
        this.searchInfo.termId = '';
        this.searchInfo.schoolyearId = '';
        this.searchInfo.semester = '';
      }

      this.pageInfo.pageIndex = 1;
    },

    // 切换课程成果显示
    toggleShowCourseKind() {
      this.showMoreCourseKind = !this.showMoreCourseKind;
    },

    // 切换课程成果
    courseResultChange(item) {
      this.searchInfo.courseResultsId = item.id;
      this.searchInfo.selectedAchievementKind = item.name;
      this.handleSearch();
    },

    // 切换学期显示
    toggleShowTerm() {
      this.showMoreTerm = !this.showMoreTerm;
    },

    // 切换学期
    termChange(item) {
      this.searchInfo.termId = item.semester_id;
      this.searchInfo.schoolyearId = +item.schoolyear_id;
      this.searchInfo.semester = item.id;
      this.handleSearch();
    },

    // 切换学院显示
    toggleShowCollege() {
      this.showMoreCollege = !this.showMoreCollege;
    },

    // 切换学院
    collegeChange(item) {
      this.searchInfo.collegeId = item.id;
      this.searchInfo.collegeName = item.name;
      this.handleSearch();
    },

    twoCollegeChange(item) {
      this.searchInfo.collegeId = item.id;
      this.searchInfo.collegeName = item.organName;
      this.handleSearch();
    },

    // 切换学科显示
    toggleShowSubject() {
      this.showMoreSubject = !this.showMoreSubject;
    },

    // 切换一级学科
    oneSubjectChange(item) {
      this.searchInfo.subjectId = item.id;
      this.searchInfo.subjectName = item.name;
      this.handleSearch();
    },

    // 切换二级学科
    twoSubjectChange(item) {
      // this.searchInfo.subjectTwoId = item.id
      this.searchInfo.subjectId = item.id;
      this.searchInfo.subjectName = item.subjectName;
      this.handleSearch(); // console.log('two', this.searchInfo.subjectTwoId);
    },

    // 切换分页
    pageIndexChange(current) {
      this.pageInfo.pageIndex = current;
      this.getCourseList();
    },

    async getAuth() {
      let navItemInfo = JSON.parse(sessionStorage.getItem('authInfo'));
      const res2 = await this.$http.getConfigList();

      if (this.courseType == 1) {
        this.authType = navItemInfo.find(item => item.function_id == '10401').auth_type;
      } else {
        this.authType = navItemInfo.find(item => item.function_id == '10402').auth_type;
      }
    }

  }
};